import React from "react";
import { Avatar, Box, Card, Grid, Typography } from "@mui/material";
import { WorkList } from "../../store/types/work.types";
import { getTeamColor } from "../../utils/workItemUtils";
import { useWorkPanel } from "../../hooks/useWorkPanel";
import WorkListItem from "../workitem/WorkListItem";

interface WorkCardViewProps {
  works: WorkList[];
}

const WorkCardView: React.FC<WorkCardViewProps> = ({ works }) => {
  const { openWork } = useWorkPanel();

  return (
    <Grid container spacing={3}>
      {works.map((work) => (
        <Grid item xs={12} md={6} lg={4} key={work.Id}>
          <Card
            elevation={2}
            onClick={() => openWork(work.Id)}
            sx={{
              height: "100%",
              cursor: "pointer",
              transition: "all 0.2s",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 5,
              },
            }}
          >
            {/* Header — team color + customer info */}
            <Box
              sx={{
                display: "flex",
                p: 2,
                bgcolor: getTeamColor(work.Team?.Id),
                color: "white",
                alignItems: "center",
                minHeight: 64,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "rgba(255,255,255,0.2)",
                  color: "white",
                  width: 40,
                  height: 40,
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  mr: 2,
                }}
              >
                {work.Customer?.Name?.charAt(0) || "?"}
              </Avatar>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1rem",
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {work.Customer?.Name || "Ingen kund"}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.9, fontSize: "0.8rem" }}
                >
                  {work.Customer?.CustomerId || "Inget kundnummer"}
                </Typography>
              </Box>
            </Box>

            {/* Content — delegated to WorkListItem */}
            <Box sx={{ p: 2 }}>
              <WorkListItem
                workType={work.Type}
                title={work.Name}
                description={work.Description}
                state={work.State}
                categoryName={work.Category?.Name}
                teamName={work.Team?.Name}
                teamId={work.Team?.Id}
                assignedToName={work.AssignedTo?.Name}
                modified={work.Modified}
              />
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default WorkCardView;
